import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

/**
 * Props for {@link ItemDetailCard}.
 */
export interface ItemDetailCardProps {
  children: React.ReactNode;
}

/**
 * Bordered, padded column card used for the single-card sections of the
 * item-detail panel (badges / rows / description). Multi-card sections
 * (purchase history, related variant packs) stamp this once per entry.
 *
 * @param props - {@link ItemDetailCardProps}.
 * @returns The rendered card.
 */
export const ItemDetailCard: React.FC<ItemDetailCardProps> = ({ children }) => {
  const [styles] = useStyles();
  return <View style={styles.card}>{children}</View>;
};

const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    flexDirection: 'column',
    gap: theme.sk.spacing.spaceXsmall,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceSMedium,
  },
}));
